/****************************************************************
 * File: full-page-layout.tsx
 * Description: 页面公用的布局(不含有菜单栏的布局)
 * Author: zayfen <zhangyunfeng@pudutech.com>
 * Created: 2022/05/25 17:29
 *
 * History:
 *   Date               Programmer ID    Description
 *  -----------------  ---------------  ------------------------
 *  2022/05/25 17:29   zayfen           Init
 *
 * This unpublished material is proprietary to PuduTech.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of PuduTech.
 *****************************************************************/

import { NextPage } from 'next'
import { useRouter } from 'next/router'

import { PropsWithChildren } from 'react'
import PdFooter from '../pd-footer/pd-footer'

export interface FullPageLayoutProps {
  pageTitle: string
  pageDescription: string
  pageKeywrods: string
  ogtype: 'website' | 'article'
  hideFooter?: boolean
  pageHeight?: string
  onScrollCapture?: (prevScrollTop: number, currentScrollTop: number, navbar: HTMLElement, moveBy: HTMLElement) => void
}

const FullPageLayout: NextPage<PropsWithChildren<FullPageLayoutProps>> = ({
  // pageTitle, // 移除：由 _app.tsx 统一处理
  // pageDescription,
  // pageKeywrods,
  // ogtype,
  onScrollCapture,
  children,
  hideFooter,
  pageHeight,
}) => {
  const router = useRouter()

  return (
    <div className={['container-fluid w-full h-full'].join(' ')}>
      {/* SEO 已由 _app.tsx 统一接管，此处不再渲染 Head/PdSEO */}

      <main
        id="main"
        className={['container-fluid w-full h-screen overflow-y-auto will-change-scroll', pageHeight].join(' ')}
      >
        {children}
        {!hideFooter && <PdFooter hideChangeLang={true} />}
      </main>
    </div>
  )
}

export default FullPageLayout
